// If using a module system (e.g. via vue-cli), import Vue and VueI18n and then call Vue.use(VueI18n).
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  'en-US': {
    message: {
      hello: 'hello world'
    },
    vapp: {
      title: "Customer Portal",
      navigation: {
        home: "Home",
        login: "Login",
        about: "About",
        account: "Account",
        overview: "Overview",
        logout: "Logout",
        messages: "Messages",
        qualitynotifications: "Complaints"
      },
      notification: {
        close: "Close"
      }
    },
    vlogin: {
      username: {
        label: 'Username',
        requiredHint: 'This field is required!',
        maxHint: 'Max {n} characters!'
      },
      password: {
        label: 'Password',
        requiredHint: 'This field is required!',
        minHint: 'Min {n} characters!'
      }
    },
    vaccount: {
      orders: 'Order',
      orderNumber: 'Order number',
      orderCreatedAt: 'Created at',
      orderActions: 'Actions',
      qualityNotifications: {
        title: 'Complaints',
        noPositions: 'no complaints found',
        create: 'Create complaint'
      }
    },
    voverview: {
      orderDetailsHeader: "Order {orderNumber} created at {creationDate}"
    },
    vtimeline: {
      phases: {
        orderReceival: {
          name: 'Order Received',
        },
        measuring: {
          name: 'Measuring',
        },
        designing: {
          name: 'Construction'
        },
        production: {
          name: 'Production'
        },
        delivery: {
          name: 'Delivery',
          warehouseDeliveryInfo: {
            title: 'Warehouse delivery',
            subtitle: 'The delivery destination is to one of our warehouses. For exact details on completion you will be contacted seperately.'
          }
        },
        assembly: {
          name: 'Installation',
          dateMayVary: "Please bote that the date may vary.",
          done: 'The installation of your order is finished!',
        }
      }
    },
    vqualitynotifications: {
      masterOrder: "Order",
      workOrder: "Factory order",
      note: "Note",
      attachments: "Attachments"
    },
    vqualitynotificationspositioncomponent: {
      sequence: 'Sequence number',
      createdworkorder: 'Assigned factory order',
      state: 'State',
      delivery: 'Delivery',
      installation: 'Assembly',
      problem: 'Problem',
      solution: 'Proposed solution'
    },
    components: {
      qualityNotificationsCreationDialog: {
        title: 'Create a complaint',
        masterOrder: "Order",
        workOrder: "Factory order",
        note: "Description",
        attachments: "Attachments",
        send: 'Send'
      },
      qualityNotificationPositionComponent: {
        sequence: 'Position',
        complainedWorkOrder: (ctx) => `for ${ctx.named('workOrderDisplayName')}`,
        createdworkorder: 'Created factory order',
        createdworkorderNotCreatedYet: 'not created yet',
        state: 'Position status',
        states: {
          notAccepted: 'Declined',
          accepted: 'Approved',
          done: 'Done',
          new: 'New'
        },
        deliveryCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        delivery: 'Delivery',
        deliveryNotCreatedYet: 'not created yet',
        installationCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        installation: 'Installation',
        installationNotCreatedYet: 'not created yet',
        problem: 'Problem description',
        solution: 'Solution',
        files: 'Files',
        noFilesAttached: 'No files found',
        fileDownload: 'Download'
      },
      qualityNotificationComponent: {
        createdOn: (ctx) => `created on ${ctx.named('formattedDate')}`,
        asignee: 'Asignee',
        notificationStatus: 'Complaint status',
        statuses: {
          new: 'New',
          inProcessing: 'In Processing',
          done: 'Done',
          notAccepted: 'Not accepted'
        },
        deliveryCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        delivery: 'Delivery',
        deliveryNotCreatedYet: 'not created yet',
        installationCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        installation: 'Installation',
        installationNotCreatedYet: 'not created yet'
      }
    }
  },
  'de-DE': {
    message: {
      hello: 'hallo welt'
    },
    vapp: {
      title: "Kundenportal",
      navigation: {
        home: "Home",
        faq: 'FAQ',
        login: "Anmelden",
        about: "Über",
        account: "Profil",
        overview: "Überischt",
        logout: "Abmelden",
        messages: "Nachrichten",
        qualitynotifications: "Qualitätsmeldungen"
      },
      notification: {
        close: "Schließen"
      }
    },
    vlogin: {
      username: {
        label: 'Benutzername',
        requiredHint: 'Feld darf nicht leer sein!',
        maxHint: 'Maximal {n} Zeichen!'
      },
      password: {
        label: 'Passwort',
        requiredHint: 'Feld darf nicht leer sein!',
        minHint: 'Mindestens {n} Zeichen!'
      }
    },
    vaccount: {
      orders: 'Aufträge',
      orderNumber: 'Auftragsnummer',
      orderCreatedAt: 'Erstellt am',
      orderActions: 'Aktionen',
      qualityNotifications: {
        title: 'Serviceanfragen',
        noPositions: 'keine Serviceanfragen vorhanden',
        create: 'Serviceanfrage erfassen'
      }
    },
    voverview: {
      orderDetailsHeader: `Details zum Auftrag {orderNumber} vom {creationDate}`
    },
    vtimeline: {
      phases: {
        orderReceival: {
          name: 'Auftragseingang',
        },
        measuring: {
          name: 'Aufmaß',
        },
        designing: {
          name: 'Konstruktion'
        },
        production: {
          name: 'Produktion'
        },
        delivery: {
          name: 'Lieferung',
          warehouseDeliveryInfo: {
            title: 'Lagerlieferung',
            subtitle: 'Die Auslieferung ihres Auftrags erfolgt in eines unserer Außenläger. Für genauere Informationen des Fertigstellungstermins werden sie gesondert kontaktiert.'
          }
        },
        assembly: {
          name: 'Montage',
          dateMayVary: "Bitte beachten Sie, dass der Termin sich ändern kann.",
          done: 'Die Montage Ihres Auftrags ist abgeschlossen!',
        }
      }
    },
    components: {
      qualityNotificationsCreationDialog: {
        title: 'Serviceanfrage erfassen',
        masterOrder: "Hauptauftrag",
        workOrder: "Werksauftrag",
        note: "Bemerkung",
        attachments: "Anhänge",
        send: 'Abschicken'
      },
      qualityNotificationPositionComponent: {
        sequence: 'Position',
        complainedWorkOrder: (ctx) => `zu ${ctx.named('workOrderDisplayName')}`,
        createdworkorder: 'Angelegter Werksauftrag',
        createdworkorderNotCreatedYet: 'noch nicht angelegt',
        state: 'Status',
        states: {
          notAccepted: 'Abgelehnt',
          accepted: 'Freigegeben',
          done: 'Abgeschlossen',
          new: 'Neu'
        },
        deliveryCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        delivery: 'Lieferung',
        deliveryNotCreatedYet: 'noch nicht angelegt',
        installationCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        installation: 'Montage',
        installationNotCreatedYet: 'noch nicht angelegt',
        problem: 'Problembeschreibung',
        solution: 'Lösung',
        files: 'Dateien',
        noFilesAttached: 'keine Dateien verfügbar',
        fileDownload: 'Herunterladen'
      },
      qualityNotificationComponent: {
        createdOn: (ctx) => `erfasst am ${ctx.named('formattedDate')}`,
        asignee: 'Bearbeiter',
        notificationStatus: 'Meldungs-Status',
        statuses: {
          new: 'Neu',
          inProcessing: 'In Bearbeitung',
          done: 'Abgeschlossen',
          notAccepted: 'Abgelehnt'
        },
        deliveryCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        delivery: 'Lieferung',
        deliveryNotCreatedYet: 'noch nicht angelegt',
        installationCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        installation: 'Montage',
        installationNotCreatedYet: 'noch nicht angelegt'
      }
    }
  }
}

const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    zCustomMonthYear: {
      year: 'numeric',
      month: 'long',
    }
  },
  'de-DE': {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
    zCustomMonthYear: {
      year: 'numeric',
      month: 'long',
    }
  }
}

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: "symbol"
    }
  },
  'de-DE': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol'
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'de-DE', // set locale
  messages: messages, // set locale messages
  dateTimeFormats: dateTimeFormats,
  numberFormats: numberFormats
})

export default i18n